import { render, staticRenderFns } from "./CompanyEmailSetting.vue?vue&type=template&id=01359762&scoped=true"
import script from "./CompanyEmailSetting.vue?vue&type=script&lang=js"
export * from "./CompanyEmailSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmailSetting.vue?vue&type=style&index=0&id=01359762&lang=scss&scoped=true"
import style1 from "./CompanyEmailSetting.vue?vue&type=style&index=1&id=01359762&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01359762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01359762')) {
      api.createRecord('01359762', component.options)
    } else {
      api.reload('01359762', component.options)
    }
    module.hot.accept("./CompanyEmailSetting.vue?vue&type=template&id=01359762&scoped=true", function () {
      api.rerender('01359762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyEmailSetting.vue"
export default component.exports